var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H34C41.732 0 48 6.26801 48 14V34C48 41.732 41.732 48 34 48H14C6.26801 48 0 41.732 0 34V14Z",
    fill: "#FB2C36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7304 30L25.7304 16C25.556 15.6922 25.303 15.4362 24.9973 15.258C24.6917 15.0799 24.3442 14.9861 23.9904 14.9861C23.6366 14.9861 23.2892 15.0799 22.9835 15.258C22.6778 15.4362 22.4249 15.6922 22.2504 16L14.2504 30C14.0741 30.3053 13.9816 30.6519 13.9824 31.0045C13.9832 31.3571 14.0772 31.7032 14.2549 32.0078C14.4325 32.3124 14.6876 32.5646 14.9941 32.7388C15.3007 32.9131 15.6478 33.0032 16.0004 33H32.0004C32.3513 32.9996 32.6959 32.9069 32.9997 32.7313C33.3035 32.5556 33.5556 32.3031 33.7309 31.9991C33.9062 31.6951 33.9985 31.3504 33.9984 30.9995C33.9983 30.6486 33.9059 30.3039 33.7304 30Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21V25",
    stroke: "#FB2C36",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 29H24.01",
    stroke: "#FB2C36",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.92d33d639365cc624d95f134ae03aec3.svg";
export { ForwardRef as ReactComponent };